import React, { useEffect, useState } from 'react'
import { Col, FormGroup, Input, Row, Alert } from 'reactstrap'
import { beanTypeOptions, sizeOptions } from './constants'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { useFormUtils } from 'views/shared/useFormUtils'
import Select from 'react-select'
import PropTypes from 'prop-types'

const DryBeansPackageReview = ({ item, isDisabled }) => {
  const [packaging, setPackaging] = useState({
    fkCategory: item.fkCategory,
    fkSubCategory: item.fkSubCategory,
    BeanPeaLentilType: item.BeanPeaLentilType,
    BeanPeaLentilSize: item.BeanPeaLentilSize,
  })
  const methods = useFormContext()
  const { setSelectReviewer, asterisk } = useFormUtils()
  useEffect(() => {
    if (item !== null) {
      const { BeanPeaLentilType, BeanPeaLentilSize } = item
      setPackaging({
        BeanPeaLentilType,
        BeanPeaLentilSize,
      })
    }
    // eslint-disable-next-line
    }, [item])

  return (
    <>
      <Row>
        <Col xs={4}>
          <FormGroup>
            <h6>Bean Type {asterisk}</h6>
            <Controller
              as={Select}
              className="react-select primary"
              classNamePrefix="react-select"
              options={beanTypeOptions}
              defaultValue={{
                label: packaging.BeanPeaLentilType,
                value: packaging.BeanPeaLentilType,
              }}
              name="BeanPeaLentilType"
              control={methods.control}
              rules={{ required: true }}
              placeholder={'Select Type'}
              onChange={([selected, value]) => {
                setSelectReviewer(item, selected, value)
                return selected
              }}
              isDisabled={isDisabled}
            />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="BeanPeaLentilType"
                message={'⚠ Bean type is required.'}
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
          <br />
          <FormGroup>
            <h6>Size {asterisk}</h6>
            <Controller
              as={Select}
              className="react-select primary"
              classNamePrefix="react-select"
              options={sizeOptions}
              defaultValue={{
                label: packaging.BeanPeaLentilSize,
                value: packaging.BeanPeaLentilSize,
              }}
              name="BeanPeaLentilSize"
              control={methods.control}
              rules={{ required: true }}
              placeholder={'Select Size'}
              onChange={([selected, value]) => {
                setSelectReviewer(item, selected, value)
                return selected
              }}
              isDisabled={isDisabled}
            />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="BeanPeaLentilSize"
                message={'⚠ Bean size is required.'}
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
        </Col>
      </Row>
    </>
  )
}

DryBeansPackageReview.propTypes = {
  item: PropTypes.object,
  isDisabled: PropTypes.bool,
}

export default DryBeansPackageReview
